(function() {
  "use strict";

  // Carrega uma reserva ao clicar em ver detalhes
  $(".btn-det-contato").on("click", function(e) {
    e.preventDefault();
    var id = $(this).data("id");
    var img = $(this).data("img");
    var titulo = $(this).data("titulo");
    var url = $(this).data("url");
    var usuario = $(this).data("usuario");
    var email = $(this).data("email");
    var telefone = $(this).data("telefone");
    var data = $(this).data("data");
    var msg = $(this).data("msg");
    $("#det-contato-img").get(0).src = img;
    $(".det-contato-titulo").text(titulo);
    $(".det-contato-data").text(data);
    $("#det-contato-url").get(0).href = url;
    $("#det-contato-nome").val(usuario);
    $("#det-contato-email").val(email);
    $("#det-contato-telefone").val(telefone);
    $("#det-contato-data").val(data);
    $("#det-contato-msg").val(msg);
    $("#anuncios_contatos_id").val(id);
    openModal("modal-contato");
  });


  $(".btn-det-avaliacao").on("click", function(e) {
    e.preventDefault();
    var id = $(this).data("id");
    var img = $(this).data("img");
    var titulo = $(this).data("titulo");
    var url = $(this).data("url");
    var usuario = $(this).data("usuario");
    var email = $(this).data("email");
    var telefone = $(this).data("telefone");
    var data = $(this).data("data");
    var msg = $(this).data("msg");
    $("#det-avaliacao-img").get(0).src = img;
    $(".det-avaliacao-titulo").text(titulo);
    $(".det-avaliacao-data").text(data);
    $("#det-avaliacao-url").get(0).href = url;
    $("#det-avaliacao-nome").val(usuario);
    $("#det-avaliacao-email").val(email);
    $("#det-avaliacao-telefone").val(telefone);
    $("#det-avaliacao-data").val(data);
    $("#det-avaliacao-msg").val(msg);
    openModal("modal-avaliacao");
  });

  // RESPONDE AVALICAO
  var enviando_formulario2 = false;
  $("#det-contato-form").on("submit", function(e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();
    function volta_submit() {
      enviando_formulario2 = false;
      hideLoading();
    }
    if (!enviando_formulario2) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function() {
          closeModal("modal-contato");
          showLoading();
          enviando_formulario2 = true;
        },
        success: function(data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            showAlert(
              "Sucesso",
              "Resposta enviada com sucesso.",
              "success"
            );
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function(xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        }
      });
    }
  });

  // REMOVE CONTATO
  var enviando_formulario = false;
  $("#form-remove-contato").on("submit", function(e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function() {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function(data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $("#id_remove").val("");
            showAlert(
              "Sucesso",
              "O registro foi removido com sucesso.",
              "success"
            );
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function(xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        }
      });
    }
  });
})();
